import { StemType } from '@arpeggi/shared'
import { observer } from 'mobx-react-lite'
import { Dispatch, FC, SetStateAction } from 'react'
import { LOOP_COLORS } from '../../../lib/stitches'
import { useTreeState } from '../../../stores/Root'
import { IStemStore } from '../../../stores/song/StemStore'
import { SelectedTrackContainerTabs } from '../SelectedTrackContainer'
import CanvasPianoRoll from './canvas-piano-roll/CanvasPianoRoll'
import ClipEditor from './ClipEditor'
import DrumSequencer from './DrumSequencer'
import InstrumentADSR from './InstrumentADSR'
import LoopSelector from './LoopSelector'

interface Props {
  stem: IStemStore
  selectedTab: number | string
  stemIndex: number
  selectedDrumTrack: number
  setSelectedDrumTrack: Dispatch<SetStateAction<number>>
}
const STCBody: FC<Props> = ({
  stem,
  selectedTab,
  stemIndex,
  selectedDrumTrack,
  setSelectedDrumTrack
}) => {
  const { studio } = useTreeState()
  const loop = stem.getLoopAtSectionOrNull(studio.selectedSection)
  const selectedSample = stem.getCurrentSample()

  return (
    <>
      {/* Note Editors */}
      {selectedTab === SelectedTrackContainerTabs.pianoRoll && (
        <>
          {loop && stem.type() === StemType.DRUMS && (
            <DrumSequencer
              noteColor={LOOP_COLORS[stem.colorIndex % LOOP_COLORS.length]}
              stemIndex={stemIndex}
              selectedDrumTrack={selectedDrumTrack}
              setSelectedDrumTrack={setSelectedDrumTrack}
            />
          )}
          {loop && stem.type() === StemType.INSTRUMENT && <CanvasPianoRoll />}
          {stem.type() === StemType.DRUMS && <LoopSelector stemIndex={stemIndex} />}
          {stem.type() === StemType.AUDIO && <ClipEditor stemIndex={stemIndex} />}
        </>
      )}
      {/* Instrument Editors */}
      {selectedTab === SelectedTrackContainerTabs.instrument && (
        <InstrumentADSR stem={stem} selectedSample={selectedSample} stemIndex={stemIndex} />
      )}
    </>
  )
}

export default observer(STCBody)
